import React from 'react';

import withModal from '../../../../../../components/global/modal/withModal';
import RosterIdentityTagAssignment from '.';

export const IDENTITY_TAG_ASSIGNMENT_MODAL =
  'modals/IDENTITY_TAG_SELECTION_MODAL';

const RosterIdentityTagAssignmentnModal = props => (
  <RosterIdentityTagAssignment {...props} />
);

export default withModal(RosterIdentityTagAssignmentnModal, {
  name: IDENTITY_TAG_ASSIGNMENT_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  overlayClassName: 'z-modal-max',
});
